import { Box, Divider, Flex, Text } from "@chakra-ui/react"
import moment from "moment";
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider";
import React from "react"

const PrintDetails = React.forwardRef((props, ref: any) => {

    const { currentReservation: reservation } = useReservationsContext()
    const { T } = useUI()
    const washStartTime = moment(reservation?.startDateTime).format("DD/MM - HH:mm")
    return (
        <Box ref={ref} >

            {reservation?.hasDiscount ?
                <Flex style={{
                    flexDirection: "column",
                    alignItems: "center",
                    width: "400px"
                }}>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.time")}: </Text><Text fontSize="23px" fontWeight="bold">{washStartTime}</Text>
                    </Flex>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.gov_number")}:</Text> <Text fontSize="25px" fontWeight="bold">{reservation?.vehicleGovNumber}</Text>
                    </Flex>
                    <Text fontSize="23px">{T("print.category")}: {reservation?.vehicleBodyType}</Text>
                    <Text fontSize="23px">{T("print.wash_type")}: <span>{reservation?.washType}</span></Text>
                    <Text fontSize="23px">{T("print.washer")}: <Text as="span" fontWeight="bold">{reservation?.washerEmployee}</Text></Text>
                    <Flex gap={1} style={{ wordBreak: "keep-all", alignItems: "center", justifyContent: "center" }}>
                        <Text fontSize="23px" whiteSpace="nowrap" >{T("print.service_price")}: </Text>
                        <Text whiteSpace="nowrap" fontSize="26px" fontWeight="bold">{reservation?.price}₾</Text>
                    </Flex>
                    <Text fontSize="23px">{T("print.discount_type")}: </Text>
                    <Text fontSize="23px">{reservation?.discountType}</Text>
                    <Text fontSize="23px">{T("print.discount_percent")}: {reservation?.discountPercent}</Text>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.price")}:</Text><Text fontSize="23px" fontWeight="bold">{reservation?.toTalPrice}₾</Text>
                    </Flex>
                    <Divider />
                    <Text fontSize="23px" >{"Qapp.ge"}</Text>
                    <Text fontSize="23px" >{"Powered by BDS.ge"}</Text>
                </Flex>
                : <Flex style={{
                    flexDirection: "column",
                    alignItems: "center",
                    width: "400px"
                }}>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.time")}: </Text><Text fontSize="23px" fontWeight="bold">{washStartTime}</Text>
                    </Flex>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.gov_number")}:</Text> <Text fontSize="23px" fontWeight="bold">{reservation?.vehicleGovNumber}</Text>
                    </Flex>
                    <Text fontSize="23px">{T("print.category")}: {reservation?.vehicleBodyType}</Text>
                    <Text fontSize="23px">{T("print.wash_type")}: {reservation?.washType}</Text>
                    <Text fontSize="23px">{T("print.washer")}: <Text as="span" fontWeight="bold">{reservation?.washerEmployee}</Text></Text>
                    <Flex gap={1}>
                        <Text fontSize="23px">{T("print.price")}:</Text>
                        <Text fontSize="23px" fontWeight="bold">{reservation?.toTalPrice}₾</Text>
                    </Flex>
                    <Divider />
                    <Text fontSize="23px">{"Qapp.ge"}</Text>
                    <Text fontSize="23px">{"Powered by BDS.ge"}</Text>
                </Flex>
            }
        </Box>

    );
});


PrintDetails.displayName = "PrintDetails";
export default PrintDetails;
